import { useEffect } from "react";
import { useState } from "react";
import { toast } from "react-toastify";
import moment from 'moment';
import { getSellerOrders, getSettlementHistory, getSettlements, updateSettledOrders } from "../actions"
import { validatePayNow, validatePaynowOnChange } from "../validators";

export const useSettlementListHook = ({
   isTransactionHistory,
   selectedDates = [],
   sellerId = ""
}) => {
   const [paginationData, setPaginationData] = useState({
      limit: 10,
      skip: 0,
      page: 0,
      total: 0
   })

   const [sellers, setSellers] = useState([])
   const [isLoading, setIsLoading] = useState(true);
   const [localization, setLocalization] = useState({});
   const [isPayNowModalOpen, setIsPayNowModalOpen] = useState(false);
   const [paymentData, setPaymentData] = useState({});
   const [isPayNowLoading, setIsPayNowLoading] = useState(true);
   const [errorMessages, setErrorMessages] = useState({});

   useEffect(() => {
      const updatedPaginationData = {
         limit: paginationData.limit || 10,
         skip: 0,
         page: 0,
         total: 0
      }

      fetchSettlementList({ ...updatedPaginationData })
   }, [isTransactionHistory, selectedDates])

   const fetchSettlementList = async (updatedPaginationData = { ...paginationData }, filterData = {}) => {
      try {
         setIsLoading(true)
         setSellers([])

         let sellersData = []
         const fromDate = selectedDates && selectedDates.length > 0 ? moment.utc(selectedDates[0]).format("YYYY-MM-DD") : ""
         const toDate = selectedDates && selectedDates.length > 0 ? moment.utc(selectedDates[1]).format("YYYY-MM-DD") : ""

         if (isTransactionHistory) {
            const historyPayload = {
               limit: updatedPaginationData.limit || 10,
               skip: updatedPaginationData.skip || 0,
               seller_id: sellerId || "",
               fromDate: fromDate,
               toDate: toDate,
               business_name: filterData.business_name || "",
               mobile_no: filterData['food_seller.user.mobile_no'] || ""
            }

            const settlementHistoryData = await getSettlementHistory(historyPayload)

            let responseData = (settlementHistoryData.data && settlementHistoryData.data.ResponseData) || []
            sellersData = ((responseData && responseData.settlements) || [])

            setPaginationData({
               ...updatedPaginationData,
               total: responseData.total || 0
            })
         } else {
            const sellersQueryParams = {
               limit: updatedPaginationData.limit || 10,
               skip: updatedPaginationData.skip || 0,
               seller_id: sellerId || "",
               fromDate: fromDate,
               toDate: toDate,
               business_name: filterData.business_name || "",
            }

            const settlementData = await getSettlements(sellersQueryParams)
            let responseData = (settlementData.data && settlementData.data.ResponseData) || []
            sellersData = ((responseData && responseData.sellers) || []).map((seller) => {
               return {
                  ...seller,
                  isAllOrderSelected: true,
                  isAnyOrderSelected: true,
                  settlementAmount: seller.payment_details.settlement_amount || seller.payment_details.payable_amount
               }
            })

            setPaginationData({
               ...updatedPaginationData,
               total: responseData.total || 0,
            })
         }

         setSellers(sellersData)
         fetchOrdersForAllSellers([...sellersData])
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false)
      }
   }

   const fetchOrdersForAllSellers = async (sellersData) => {
      try {
         const sellersWithOrders = []
         // const oldIsTransactionHistory = isTransactionHistory
         for (const sellerData of sellersData) {
            const sellerOrders = await fetchOrderData(sellerData.seller_id, sellerData.settlement_id)
            const settlementAmount = [...sellerOrders].reduce((defaultValue, orderData) => {
               let amount = 0
               if (orderData.isSelected) {
                  if (orderData.settlementAmount || orderData.settlementAmount === 0 || orderData.settlement_amount || orderData.settlement_amount === 0) {
                     amount = orderData.settlementAmount || orderData.settlement_amount
                  } else {
                     amount = orderData.payable_amount
                  }
               }

               return defaultValue + amount
            }, 0)

            sellersWithOrders.push({
               ...sellerData,
               isAnyOrderSelected: true,
               settlementAmount: settlementAmount,
               orders: [...sellerOrders],
            })
         }

         setSellers([...sellersWithOrders])

         // if (oldIsTransactionHistory === isTransactionHistory) {
         // setSellers([...sellersWithOrders])
         // }
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false)
      }
   }

   const fetchOrderData = async (sellerId, settilementId = "") => {
      try {
         const fromDate = selectedDates && selectedDates.length > 0 ? moment.utc(selectedDates[0]).format("YYYY-MM-DD") : ""
         const toDate = selectedDates && selectedDates.length > 0 ? moment.utc(selectedDates[1]).format("YYYY-MM-DD") : ""

         const ordersDetails = await getSellerOrders(sellerId, isTransactionHistory, settilementId, fromDate, toDate)
         let ordersData = (ordersDetails.data && ordersDetails.data.ResponseData) || []
         ordersData = ordersData.map((order) => {
            return {
               ...order,
               settlementAmount: order.settlement_amount,
               isSelected: true
            }
         })

         return ordersData
      } catch (error) {
         console.log(error);
      } finally {
         setIsLoading(false)
      }
   }

   const updateSettlementAmount = (settlementData, selectedSellerData = {}) => {
      const sellerIndex = selectedSellerData.tableData && selectedSellerData.tableData.id
      let sellersClone = [...sellers]
      sellersClone[sellerIndex] = {
         ...sellersClone[sellerIndex],
         orders: [...settlementData.orders],
         isAllOrderSelected: settlementData.isAllOrderSelected,
         isAnyOrderSelected: settlementData.isAnyOrderSelected,
         settlementAmount: settlementData.totalSettlementAmount
      }
      setSellers([...sellersClone])
   }

   const togglePaymentModal = (isOpen, sellerData = {}) => {
      try {
         const selectedOrders = [...(sellerData.orders || [])].filter((order) => order.isSelected)
         setIsPayNowModalOpen(isOpen)
         if (isOpen) {
            const settlementAmount = sellerData.settlementAmount || sellerData.settlementAmount === 0 || sellerData.settlement_amount || sellerData.settlement_amount === 0 ? (sellerData.settlementAmount || sellerData.settlement_amount) : sellerData.payable_amount

            setPaymentData({
               ...sellerData,
               sellerId: sellerData.seller_id,
               settlement_amount: settlementAmount,
               settlement_description: "",
               transaction_id: "",
               pay_incentive: false,
               account_number: (sellerData.bank_account && sellerData.bank_account.account_number) || "",
               account_holder_name: (sellerData.bank_account && sellerData.bank_account.account_holder_name) || "",
               bank_name: (sellerData.bank_account && sellerData.bank_account.bank_name) || "",
               bank_code: (sellerData.bank_account && sellerData.bank_account.bank_code) || "",
               account_id: (sellerData.bank_account && sellerData.bank_account.account_id) || "",
               orders: isOpen ? [...selectedOrders] : []
            })
         } else {
            setPaymentData({})
         }
         setErrorMessages({})
      } catch (error) {
         console.log(error);
      }
   }

   const handleInputChange = (event) => {
      const { name, value } = event.target
      console.log({ name, value });

      const errors = validatePaynowOnChange(name, value, errorMessages)
      setErrorMessages({ ...errors })
      setPaymentData({
         ...paymentData,
         [name]: value
      })
   }

   const handlePayNow = async () => {
      try {
         if (!paymentData.account_number || !paymentData.bank_code) {
            toast.info("Seller Need to add there primary bank acocunt in their account first.")
            return
         }

         const errors = validatePayNow(paymentData)
         setErrorMessages({ ...errors })

         if (Object.keys(errors).length > 0) {
            return
         }

         setIsPayNowLoading(true)

         const sellerOrdersClone = [...(paymentData.orders || [])]

         const selectedOrdersData = {
            net_amount: 0,
            tax: 0,
            delivery_charges: 0,
            convience_charges: 0,
            payable_amount: 0,
         }
         const selectedOrders = sellerOrdersClone.filter((order) => order.isSelected).map(((order) => {
            selectedOrdersData.net_amount += order.net_amount
            selectedOrdersData.tax += order.tax
            selectedOrdersData.delivery_charges += order.delivery_charges
            selectedOrdersData.convience_charges += order.convenience_fees
            selectedOrdersData.payable_amount += order.payable_amount

            const settlement_amount = (order.settlementAmount || order.settlementAmount === 0 || order.settlement_amount || order.settlement_amount === 0) ? order.settlementAmount || order.settlement_amount : order.payable_amount

            return {
               order_id: order.order_id || "",
               settlement_amount: settlement_amount || 0,
               settlement_description: order.settlement_description || ""
            }
         }))

         const sellerId = paymentData.seller_id
         const settlePayload = {
            settlement_amount: paymentData.settlement_amount,
            settlement_description: paymentData.settlement_description,
            pay_incentive: paymentData.pay_incentive,
            transaction_id: paymentData.transaction_id,
            bank_account_id: paymentData.account_id,
            orders: [...selectedOrders]
         }

         let settleData
         try {
            settleData = await updateSettledOrders(sellerId, settlePayload)

            let sellersClone = [...sellers]
            const sellerIndex = paymentData.tableData && paymentData.tableData.id

            if (sellerIndex > -1) {
               const sellerData = { ...sellersClone[sellerIndex] }
               const sellersOrders = sellerData.orders || []
               const remaningOrders = sellersOrders.filter((sellerOrder) => {
                  return !selectedOrders.some((order) => order.order_id === sellerOrder.order_id)
               })

               if (remaningOrders.length > 0) {
                  const updatedSellerData = {
                     ...sellerData,
                     isAnyOrderSelected: false,
                     settlementAmount: 0,
                     payment_details: {
                        ...sellerData.payment_details,
                        total_orders: sellerData.payment_details.total_orders - settlePayload.orders.length,
                        settlement_amount: 0,
                        net_amount: (paymentData.payment_details.net_amount - selectedOrdersData.net_amount) || 0,
                        tax: (paymentData.payment_details.tax - selectedOrdersData.tax) || 0,
                        delivery_charges: (paymentData.payment_details.delivery_charges - selectedOrdersData.delivery_charges) || 0,
                        convience_charges: (paymentData.payment_details.convience_charges - selectedOrdersData.convience_charges) || 0,
                        payable_amount: (paymentData.payment_details.payable_amount - selectedOrdersData.payable_amount) || 0,
                     },
                     orders: [...remaningOrders],
                  }
                  sellersClone[sellerIndex] = { ...updatedSellerData }
               } else {
                  sellersClone.splice(sellerIndex, 1)
               }

               setSellers([...sellersClone])
            }

            toast.success("Settlement success.")
            togglePaymentModal(false)
         } catch (error) {
            console.log("API Error :: ", { error });
            toast.error((error.response && error.response.data && error.response.data.ResponseText) || "Something went wrong.")
         }
      } catch (error) {
         console.log({
            error
         });
         toast.error("Something went wrong.")
      } finally {
         setIsPayNowLoading(false)
      }
   }

   const onPageChange = (activePage, selectedSize) => {
      const updatedPaginationData = {
         ...paginationData,
         page: activePage,
         limit: selectedSize,
         skip: selectedSize * activePage
      }
      fetchSettlementList({ ...updatedPaginationData })
   }

   const onFilterChange = (filterData = []) => {
      const name = (filterData && filterData[0] && filterData[0].column && filterData[0].column.field) || ""
      const value = (filterData && filterData[0] && filterData[0].value) || ""
      const searchData = {
         [name]: value
      }
      fetchSettlementList(paginationData, searchData)
   }

   return {
      sellers,
      isLoading,
      isPayNowLoading,
      localization,
      paginationData,
      isPayNowModalOpen,
      paymentData,
      errorMessages,
      updateSettlementAmount,
      togglePaymentModal,
      handlePayNow,
      handleInputChange,
      onPageChange,
      onFilterChange
   }
}